export default "__VITE_ASSET__44f6d027__"